import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Select,
  Dropdown,
  TreeSelect,
  Typography,
  InputNumber,
  Flex
} from "antd";
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  ShrinkOutlined,
  ExpandOutlined
} from "@ant-design/icons";
import CreateKitProductList from "./CreateKitProductList";
import UploadButton from "../../common/UploadButton";
import globalData from "../../../config/global_data";
import CreateAttributeList from "../../common/CreateAttributeList";
import common_api from "../../../config/common_api";
import { triggerNotification } from "../../common/notify";
const { Text } = Typography;


const CreateKitDrawer = ({ visible, onClose, setisloader, selected_prod_data = null, onProductCreate }) => {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState(null)
  const [bundleTitle, setBundleTitle] = useState("New Kit Product");
  const [imageObj, setImageObj] = useState(null);
  const [data, setData] = useState(null);
  const [stores, setStoreOptions] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [selectedValues, setSelectedValues] = React.useState([]);

  const [savedimages, setSavedimgaes] = useState(null);
  const [dropdownImage, setDropdownImage] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [savedattributes, setSavedattributes] = useState(null);
  const [selectedStoreID, setSelectedStoreID] = useState(null);
  const [innerProducts, setInnerProducts] = useState(null);

  const ButtonItems = [
    {
      label: 'Save & Draft',
      key: 'saveDraft',
      disabled: true
    },
    {
      label: 'Save & Reload',
      key: 'saveReload',
      disabled: true
    },
  ];
  // const handleInputChange = (name) => (e) => {
  //   const value = e.target.value.replace(/[^\d.]/g, '');
  //   form.setFieldsValue({ [name]: value });
  // };
  const handleInputChange = (name) => (e) => {
    let value = e.target.value;
    // Remove non-numeric characters except dot
    value = value.replace(/[^0-9.]/g, '');
    // Allow only one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1]; // ignore extra dots
    }
  };
  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };

  useEffect(() => {
    // if (globalData.store_list && globalData.store_list.length > 0) {
    //   setStoreOptions(globalData.store_list)
    // }
    if (globalData.store_list && globalData.store_list.length > 0) {
      let final_storelist = globalData.store_list.filter(val => val.value != "all")
      setStoreOptions(final_storelist);
    }
    // savedimages(null)
  })
  const handleSaveAndPublish = async (values) => {    
    if (!innerProducts || innerProducts.length < 2) {
      triggerNotification({
        type: 'error',
        title: 'Error!',
        message: "Please Add Secondary and Primary Products",
      });
      return 1
    }
    let images = []
    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }
      })
    }
    let custom_fields_final = [], msrp = 0, sale_price = 0

    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      await data.forEach(attr => {
        const { pattern, values, attribute_key, max_size } = attr;
        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "name": baseKey.replace("NUM", counter),
                "value": item
              }
            } else if (max_size === 1) {
              itemobj = {
                "name": baseKey,
                "value": item
              }
            }
            else {
              itemobj = {
                "name": baseKey + "_" + counter,
                "value": item
              }
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    // innerProducts.length > 2
    if (innerProducts && innerProducts.length > 0) {
      innerProducts.forEach((item, index) => {
        if (item.value != "undefined") {

          let itemobj = {
            "name": "Bundle_product_" + parseInt(index),
            "value": item.value
          }
          if (index === 0) {
            msrp = item.msrp
            sale_price = item.sale_price
            itemobj = {
              "name": "Bundle_product_primary",
              "value": item.value
            }
          }
          custom_fields_final.push(itemobj)
          if (item.image) {

            images.push({
              image_url: item.image.thumbUrl,
              description: item.value
            })

          }
        }
        // if(mainImage.startsWith('https://storage.googleapis.com/')){

        // }
      })
    }
    if (values.DiscountValue) {
      custom_fields_final.push({
        "name": "DISCOUNT_%",
        "value": values.DiscountValue.toString()
      })
    }
    if (values.DropdownText) {
      custom_fields_final.push({
        "name": "KIT_PRODUCT_NAME",
        "value": values.DropdownText
      })
    }
    if (dropdownImage.image_data && dropdownImage.image_data.length > 0) {
      custom_fields_final.push({
        "name": "KIT_IMG",
        "value": dropdownImage.image_data[0].thumbUrl
      })
    }

    let req_data = {
      "store": selectedStores,
      "data": {
        "name": values.KitName,
        "custom_fields": custom_fields_final,
        "categories": selectedValues,
        "type": "physical",
        "weight": 0,
        "sku": values.bcsku,
        "images": images && images.length > 0 ? images : [],
        price: parseFloat(msrp),
        sale_price: parseFloat(sale_price)
      },
      is_kit_product: true
    }
    // return 1
    setisloader(true)
    let responsedata = await common_api.create_simple_product(req_data)
    if (responsedata) {
      await onProductCreate();
      triggerNotification(responsedata)
    }
    setisloader(false)
    onClose()
  }

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete',
      message: "Please fix all errors before saving.",
    });
  };

  const handleBlur = () => {
    const bundleName = form.getFieldValue("KitName");
    if (bundleName && bundleName.trim()) {
      setBundleTitle(bundleName);
    } else {
      setBundleTitle("New Kit Product");
    }
  };

  const onChange = (values) => {
    setSelectedValues(values);
  };
  const store_options_handleChange = async (value) => {
    let store_id_data = await globalData.store_list.filter(item => item.value === value)
    if (globalData.all_cat_list && globalData.all_cat_list.length > 0) {
      let cattree = await globalData.all_cat_list.filter(item => item.store_id === store_id_data[0].store_id)
      if (cattree && cattree.length > 0) {
        setTreeData(cattree[0].treedata)
      }
    }
    setSelectedStoreID(store_id_data[0].store_id)
    setSelectedStores(value);
  };
  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>
            {/* <Button danger>
              <DeleteOutlined />
            </Button> */}
            <Dropdown.Button
              type="primary"
              icon={<DownOutlined />}
              menu={{
                items: ButtonItems,
                onClick: handleMenuClick,
              }}
              trigger={['click']}
              onClick={handleSaveAndPublishClick}
              style={{ marginLeft: 8 }}
            >
              Save & Publish
            </Dropdown.Button>
          </div>
        </>
      }
    >
      <Form layout="vertical" form={form}
        onValuesChange={(changedValues, allValues) => {
          if (changedValues.KitName !== undefined) {
            if (changedValues.KitName && changedValues.KitName.trim() !== "") {
              const formattedSku = changedValues.KitName.replace(/\s+/g, "-");
              form.setFieldsValue({ bcsku: formattedSku });
              setBundleTitle(changedValues.KitName);
            } else {
              form.setFieldsValue({ bcsku: "" });
              setBundleTitle("New Kit Product");
            }
          }
        }}
      >
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>
          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Kit Name&nbsp;                 
                </span>
              }
              name="KitName"
              rules={[{ required: true, whitespace: true, message: "Please Enter a Kit Name" }]}
            >
              <Input placeholder="Enter a Kit Name" onChange={handleBlur} maxLength={150}/>
            </Form.Item>
          </div>
          <Flex className={`flexbox ${isExpanded ? "w-33" : ""}`}>
            <Form.Item label={
                <span>
                  Store&nbsp;                  
                </span> } name="store" className="" style={{ width: "200px" }}
              rules={[{ required: true, message: "Please Select a Store" }]}>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Store"
                options={stores}
                onChange={store_options_handleChange}
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  BC Sku&nbsp;                  
                </span>
              }
              name="bcsku"
              rules={[{ required: true,whitespace: true, message: "Please Enter BC Sku" }                
              ]}
            >
              <Input placeholder="Enter BC Sku" />
            </Form.Item>
          </Flex>
          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Product Categories&nbsp;                 
                </span>
              }
              title="Select categories from the tree."
              rules={[{ required: true, message: "Please select at least one category" }]}
            >
              <TreeSelect
                className="CategoryTree"
                multiple
                treeData={treeData}
                onChange={onChange}
                placeholder="Please select Categories"
                showSearch
                treeDefaultExpandAll
                treeNodeFilterProp="title"
              />

            </Form.Item>
          </div>
        </div>
        <Form.Item
          label={
            <span>
              PDP Gallery&nbsp;              
            </span>
          }
          name="PDPGallery"
        >
          {visible && <UploadButton setSavedimgaes={setSavedimgaes}
            product_obj={null}
            MAX_UPLOADS="50"
            delete="true"
            replace="true"
            thumbnail="true"
            hover="" />}
        </Form.Item>
        {/* Dropdown button */}
        <div className="DropdownButtonSection">
          <Text className="DropdownButtonSectionText">Dropdown button</Text>
          <span className="spanLine"></span>
        </div>
        <Form.Item
          label={
            <span>
              Dropdown Text&nbsp;             
            </span>
          }
          name="DropdownText"
          rules={[{ required: true, whitespace: true, message: "Please enter Dropdown Text" }]}
        >
          <Input placeholder="Enter Dropdown Text" onChange={handleBlur} />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Dropdown Thumbnail&nbsp;              
            </span>
          }
          name="DropdownThumbnail"
        >
          <UploadButton
            setSavedimgaes={setDropdownImage}
            MAX_UPLOADS="1"
            delete="true"
            replace="true"
            thumbnail="false"
            hover="false"
          />
        </Form.Item>

       
        <Form.Item
          label={
            <span>
              Discount Value&nbsp;             
            </span>
          }
          name="DiscountValue"
          rules={[
            { required: true, whitespace: true, message: "Please enter Discount Value" },
            {
              validator: (_, value) => {
                if (value === undefined || value === "") {
                  return Promise.resolve(); // handled by 'required'
                }
                const numericValue = parseFloat(value);
                if (numericValue < 1 || numericValue > 100) {
                  return Promise.reject("Value must be between 1 and 100");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder="Enter Discount Value"
            style={{ width: "100%" }}
            onChange={handleInputChange("DiscountValue")}
            addonAfter="%"
            type="number"
          />
        </Form.Item>

        <div className="ProductDetailBox">
          <div className="ProductDetailBox_inner">
            {visible && <CreateAttributeList setSavedattributes={setSavedattributes} />}
            {visible && selectedStoreID && <CreateKitProductList store_id={selectedStoreID} setInnerProducts={setInnerProducts} form={form} />}
          </div>
        </div>

      </Form>
    </Drawer>
  );
};

export default CreateKitDrawer;
